import { render, staticRenderFns } from "./Senha.vue?vue&type=template&id=bfa299a6&scoped=true"
import script from "./Senha.vue?vue&type=script&lang=js"
export * from "./Senha.vue?vue&type=script&lang=js"
import style0 from "./Senha.vue?vue&type=style&index=0&id=bfa299a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa299a6",
  null
  
)

export default component.exports